/**
 * @module "model/condition.model"
 * @description This model is used in conjuction with the rules.model. It contains
 * the "formula" by which a rule uses in order to determine validity (default is
 * filled). Conditions are manipulated by the condition.util and vary throughout
 * each application. See example below:
 *
 * @example { id: 'condition-1', operation: 'lessThan', targetId: '' }
 */

define('formkit/model/condition.model',['require','exports','module','./base.model','uuid'],function(require, exports, module) {
  //prettier-ignore
  var BaseModel = require('./base.model'),
      UUID      = require('uuid');

  /**
   * @class Condition
   * @augments BaseModel
   * @see {@link model/base.model.js}
   */
  var Condition = BaseModel.extend({
    /**
     * @method defaults
     *
     * @returns {Object}  an object with an id, targetId, and operation
     */

    defaults: function() {
      return {
        id: UUID.generate(),
        targetId: null,
        operation: 'filled',
      };
    },
  });

  module.exports = Condition;
});

